<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 14V22H23V14" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path d="M7 10L12 16L17 10" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path d="M12 16V2.5" :stroke="fill" stroke-linecap="round" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: 'Download',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
